// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/diabetes.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.CBGDateTraceAnimated--border--mtaT9 {
  stroke: white;
  stroke-width: 0.5px;
}

.CBGDateTraceAnimated--veryLow--sjS5C {
}

.CBGDateTraceAnimated--low--mSdDN {
}

.CBGDateTraceAnimated--target--VDRRV {
}

.CBGDateTraceAnimated--high--q6Zsk {
}

.CBGDateTraceAnimated--veryHigh--kqnIl {
}
`, "",{"version":3,"sources":["webpack://./src/components/trends/cbg/CBGDateTraceAnimated.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.border {\n  stroke: white;\n  stroke-width: 0.5px;\n}\n\n.veryLow {\n  composes: border;\n  composes: bgVeryLow from '../../../styles/diabetes.css';\n}\n\n.low {\n  composes: border;\n  composes: bgLow from '../../../styles/diabetes.css';\n}\n\n.target {\n  composes: border;\n  composes: bgTarget from '../../../styles/diabetes.css';\n}\n\n.high {\n  composes: border;\n  composes: bgHigh from '../../../styles/diabetes.css';\n}\n\n.veryHigh {\n  composes: border;\n  composes: bgVeryHigh from '../../../styles/diabetes.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"border": `CBGDateTraceAnimated--border--mtaT9`,
	"veryLow": `CBGDateTraceAnimated--veryLow--sjS5C CBGDateTraceAnimated--border--mtaT9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryLow"]}`,
	"low": `CBGDateTraceAnimated--low--mSdDN CBGDateTraceAnimated--border--mtaT9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgLow"]}`,
	"target": `CBGDateTraceAnimated--target--VDRRV CBGDateTraceAnimated--border--mtaT9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgTarget"]}`,
	"high": `CBGDateTraceAnimated--high--q6Zsk CBGDateTraceAnimated--border--mtaT9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgHigh"]}`,
	"veryHigh": `CBGDateTraceAnimated--veryHigh--kqnIl CBGDateTraceAnimated--border--mtaT9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryHigh"]}`
};
export default ___CSS_LOADER_EXPORT___;
